import React from "react";
import {
  ANDROID_PLAY_STORE_URL,
  IOS_APP_STORE_URL,
  SHOW_MOBILE_APP_DOWNLOAD_BANNER,
} from "../../config";
import "./AppDownloadBanner.scss";

const AppDownloadBanner = ({ variant = "floating" }) => {
  if (!SHOW_MOBILE_APP_DOWNLOAD_BANNER) {
    return null;
  }

  const isSidebar = variant === "sidebar";
  const isAuth = variant === "auth";
  const appLinks = [
    {
      id: "ios",
      href: IOS_APP_STORE_URL,
      iconClass: "fa-brands fa-apple",
      eyebrow: "Download on the",
      title: "App Store",
    },
    {
      id: "android",
      href: ANDROID_PLAY_STORE_URL,
      iconClass: "fa-brands fa-google-play",
      eyebrow: "Get it on",
      title: "Google Play",
    },
  ];

  return (
    <div
      className={`app-download-banner app-download-banner--${variant}`}
      aria-label="Download StockHero mobile app"
    >
      <div className="app-download-banner__glow" />
      <div className="app-download-banner__content">
        {!isSidebar ? <p className="app-download-banner__eyebrow">Mobile App</p> : null}
        <h3>
          {isSidebar ? "Get the app" : isAuth ? "Get StockHero on your phone" : "Get StockHero on your phone"}
        </h3>
        {!isSidebar ? (
          <p className="app-download-banner__copy">
            {isAuth
              ? "Track bots, monitor deals, and stay connected while you are away from your desk."
              : "Track bots, monitor deals, and stay connected on the go."}
          </p>
        ) : null}
        <div className="app-download-banner__actions">
          {appLinks.map((item) => {
            const isDisabled = !item.href;

            return (
              <a
                key={item.id}
                className={`app-download-banner__link${isDisabled ? " is-disabled" : ""}`}
                href={isDisabled ? undefined : item.href}
                target={isDisabled ? undefined : "_blank"}
                rel={isDisabled ? undefined : "noopener noreferrer"}
                aria-disabled={isDisabled}
              >
                <i className={item.iconClass} aria-hidden="true" />
                <span>
                  {!isSidebar ? <small>{item.eyebrow}</small> : null}
                  <strong>{item.title}</strong>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
